import { Component, ContentChild, HostBinding, Inject, Input, TemplateRef } from '@angular/core';
import { MODAL_DEFINITION } from '../../inection-tokens';
import { ModalWindowWrapper } from '../../models';

/**
 * Usage:
 *
  <app-base-side-panel-modal [headerIcon]="'some_icon'" [headerDescription]="'some description'">
    <ng-template #content>
      ...
    </ng-template>
    <ng-template #footer>
      ...
    </ng-template>

    <ng-template #header>
      ...
    </ng-template>
  </app-base-side-panel-modal>
 *
 */
@Component({
  selector: 'app-base-side-panel-modal',
  templateUrl: './base-side-panel-modal.component.html',
  styleUrls: ['./base-side-panel-modal.component.scss'],
  standalone: false,
})
export class BaseSidePanelModalComponent {
  @HostBinding('class')
  private readonly classes = 'flex flex-col h-full';

  @Input()
  headerIcon: string;

  @Input()
  headerDescription: string;

  @Input()
  allowFooter = true;

  @ContentChild('header')
  protected headerTitleTemplate: TemplateRef<any>;

  @ContentChild('content')
  protected contentTemplate: TemplateRef<any>;

  @ContentChild('footer')
  protected footerTemplate: TemplateRef<any>;

  protected get isCloseBtnDisplayed(): boolean {
    // undefined is not equal to false, so undefined for options object fields means that user didn't provide this option and undefined used as default value.
    return this.modalWindowWrapper.modalWindow.options?.closeBtnDisplay !== false;
  }

  constructor(@Inject(MODAL_DEFINITION) public modalWindowWrapper: ModalWindowWrapper) {}
}
